<!--
 * @Author: Merlin
 * @Date: 2023-12-07 11:12:37
 * @LastEditors: Merlin
 * @LastEditTime: 2024-07-12 11:26:59
 * @Description: 
-->
<template>
    <button class="button-2rows button-blue"
        :disabled="disabled"
        :class="[
            (narrow ? 'narrow' : ''),
            oProps.size + '-size',
            ...aClassName,
        ]"
    >
        <span class="button-outer">
            <span class="button-inner">
                <em class="row-01 gap-x-1" >
                    <i class="icon-coat" v-if="$slots.icon">
                        <slot name="icon"> <!-- 插入图标 --> </slot>
                    </i>
                    <span>
                        <slot><!-- 插入文字 --></slot>
                    </span>
                    <CasinoWidgetRunningIcon
                        v-if="autoOption.isAutoBetting"
                    />
                </em>
                <!-- ▲行1行  ▼第2行 -->
                <small class="row-02" v-if="$slots.secondRow">
                    <slot name="secondRow"><!-- 插入文字 --></slot>
                </small>
            </span>
        </span>
    </button>
</template>

<script setup>
import { useAutoOptionStore } from '~/stores/cansino/autoOption';
const autoOption = useAutoOptionStore()
const oProps = defineProps({
    fullWidth: {
        type: Boolean,
        default: false,
    },
    narrow: { // 狭窄模式（主要解决 Mini 版下注面板横向空间不足的问题）
        type: Boolean,
        default: false,
    },
    size: {
        /*
            规格：高度px
            'xs': 22 -未开发
            'sm': 28
            'md': 36（默认 💎） 
            'lg': 48
            'xl': 62 -未开发
        */
        type: String,
        default: 'md',
    },
    disabled: {
        type: Boolean,
    },
});

const aClassName = computed(()=>{
    const aResult = [];
    if (oProps.fullWidth) aResult.push('full-with');
    if (autoOption.isAutoBetting) aResult.push('button-red')
    return aResult;
});



</script>


<style scoped lang="scss">
.be-center{
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
}

.button-2rows{
    font-variant-numeric: lining-nums tabular-nums;
    font-weight: 600;
    min-width: 50px; // ←观察此行，将来修改数值，或删除它
    vertical-align: bottom;
    background-color: var(--color_blue);
    // border: 1px solid var(--color_blue);
    color: var(--color_white);
    &:hover{
        filter: contrast(1.3);
    }
    &[class~=full-with]{
        width: 100%;
    }
    &+.button-2rows{
        margin-left: 10px;
    }
    &+.full-with{
        margin-left: 0px;
        margin-top: 10px;
    }
    &.narrow .button-outer{
        padding: 0 !important;
        letter-spacing: -0.5px;
    }
}
.button-2rows > .button-outer{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    position: relative;
    transition: transform .1s ease-in-out;
    z-index: 1;
    border-radius: var(--radius);
    .button-inner{
        line-height: 1.1;
        flex-direction: column;
        @extend .be-center;
        .row-01{
            flex-direction: row;
            font-style: normal;
            color: white; // 补充于 2024.06.05 19:50:36 星期三 
            @extend .be-center;
            .icon-coat{
                margin-right: 4px;
                width: 20px;
                height: 20px;
                &:deep(>*){
                    max-width: 100%;
                    max-height: 100%;
                }
            }
        }
        .row-02{
            color: #ffffffb3;
            font-size: 12px;
        }
    }
}


// ▼尺寸控制 ----------------------
.button-2rows{
    border-radius: var(--radius);
    &[class~=sm-size]{
        --radius: 6px;
        font-size: 11px;
        min-width: 70px; // 覆盖默认值 
        .button-outer{
            padding-left: 12px;
            padding-right: 12px;
            min-height: 28px;
        }
    }
    &[class~=md-size]{
        --radius: 8px;
        font-size: 12px;
        .button-outer{
            padding-left: 12px;
            padding-right: 12px;
            min-height: 36px;
        }
    }
    &[class~=lg-size]{
        --radius: 8px;
        font-size: 14px;
        .button-outer{
            padding-left: 14px;
            padding-right: 14px;
            min-height: 48px;
        }
    }
}
.narrow.lg-size{
    font-size: 13px;
}


// ▼ hover ---------------------------------------
.button-2rows:not([disabled]):hover{
    filter: contrast(1.3);
}

// ▼ active -----------------------------------
.button-2rows:not([disabled]):active{
    filter: contrast(1.4);
}
</style>


